// extracted by mini-css-extract-plugin
module.exports = {"base":"WorkspaceDetails_base__XPRxy","controls":"WorkspaceDetails_controls__21jgS","grid":"WorkspaceDetails_grid__3eIqv"};